import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import AwatiMotorsPrivacy from './pages/AwatiMotorsPrivacy';
import CaShreyashPrivacy from './pages/CaShreyashPrivacy';

function App() {
  return (
    <Router>
      <div className="App">
        <nav className="navbar">
          <div className="nav-container">
            <Link to="/" className="nav-logo">
              Privacy Policy
            </Link>
          </div>
        </nav>

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/awati-motors" element={<AwatiMotorsPrivacy />} />
          <Route path="/privacy-policy" element={<CaShreyashPrivacy />} />
        </Routes>
      </div>
    </Router>
  );
}

function HomePage() {
  return (
    <div className="home-page">
      <header className="home-header">
        <h1>Privacy Policies</h1>
        <p>Transparent and comprehensive privacy information</p>
      </header>
      <main className="home-content">
        <div className="policies-grid">
          <Link to="/awati-motors" className="policy-card">
            <h2>Awati Motors</h2>
            <p>View the privacy policy for Awati Motors application</p>
            <span className="arrow">→</span>
          </Link>
        </div>
      </main>
    </div>
  );
}

export default App;
